const hook = {
    missing_events: '你需要至少提供一個事件。',
    send_test_payload_failed: '無法发送測試内容：{{message}}',
    endpoint_responded_with_error: '端點返回了錯誤。',
};
export default Object.freeze(hook);
